import {
  SectionElement,
  defineElement,
  on
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/shop-offer-image/shop-offer-image.ts
var ShopOfferImage = class extends SectionElement {
  connectedCallback() {
    return __async(this, null, function* () {
      console.log("init section ShopOfferImage");
    });
  }
  handleClick() {
    console.log("clicked");
  }
};
__decorateClass([
  on("click")
], ShopOfferImage.prototype, "handleClick", 1);
ShopOfferImage = __decorateClass([
  defineElement("shop-offer-image")
], ShopOfferImage);
export {
  ShopOfferImage
};
